export const TYPE_CONTENT = {
  video: 0, // 视频
  picture: 1, // 图片
  article: 2, // 文章
  project: 3, // 专题
  ext_url: 4, // 外链
};

export const contentWxDescs = [
  '原来还有这种操作，服了~',
  '这里分享了一个狂拽炫酷的技能，一起get起来~',
  '这个技能666~',
  '这是高手,这是高手，这也太厉害了~',
  'wow，可以可以，666666',
  '这次我真的学到了，真是颠覆我的想象力',
  '这技能，偷偷告诉你，传女不传男~',
  '这个技能，一般人我不告诉他~',
  '我已经get到这个技能了，推荐你看看',
];

// 课程类型
export const LESSON_TYPE = {
  video: 1, // 视频类型课程
  voice: 2, // 音频类型课程
  extUrl: 3, // 外链
  live: 4 // 直播
};

// 收藏参数类型
export const FAVOR_TYPE = {
  article: 2, // 文章
  content: 3, // 内容
  camp_lesson: 4, // 训练营
  boutique_lesson: 5 // 精品课
};

// 支付方式配置文件：微信|有讲币|支付宝|
export const PAY_WECHAT = 'wechat';
export const PAY_YOJIANG_COIN = 'yojiang_coin';
export const PAY_ALIPAY = 'alipay';
export const PAY_CHANNEL = 'channel';
// 花呗免息
export const PAY_HUABEI = 'huabei_interest_free';

// 付款类型: 微信|支付宝|花呗分期
export const MONEY_TYPE_WECHAT = 86;
export const MONEY_TYPE_ALIPAY = 83;
export const MONEY_TYPE_HUABEI = 99;
export const MONEY_TYPE_UNIONPAY_INSTALLMENT = 112;
export const MONEY_TYPE_UNIONPAY_FQ = 114;

// 学习计划模块内容类型
export const MODULE_DETAILS_OBJ_TYPE = {
  live: 93, // 直播
  clock: 131, // 打卡
  exam: 132, // 考试
  material: 133, // 资料
  content: 134, // 图文
  lesson: 135, // 课程
};

// 广告类型
export const ADV_TYPE = {
  main_pop: 101, // H5首页弹窗广告
  main_suspend: 102, // H5首页悬浮广告
  schedule: 103, // H5学习课表广告
  lesson_play: 104, // H5课程播放页广告
  lesson_play_pause: 105, // H5课程播放暂停广告
  user_center: 106, // H5个人中心广告条
  series_detail: 107, // H5课程购买详情页广告条
  camp_lesson_detail: 108, // H5训练营课程详情页广告条
};
